<template>
  <div class="stock-out-info">
    <!-- tab -->
    <ContentHeader
      path-set-type="append"
      :path-info="navPathInfo"
      :show-back="true"
    />
    <div class="content-container" v-loading="loading">
      <!-- 头部 -->
      <div class="order-info-block">
        <div class="order-header">
          <div class="order-number">出库单号: {{ orderInfo.billNumber }}</div>
          <div class="order-date" v-if="orderInfo.stockOutTime">
            下单时间: {{ orderInfo.stockOutTime | parseTime }}
            <span class="ongoing"
              >此订单已经进行了{{ getInterval(orderInfo.createDate) }}天</span
            >
          </div>
          <div class="order-status">
            订单状态: {{ orderInfo.billStatusName }}
          </div>
        </div>
        <stockStatusStep
          v-if="orderInfo.billStatus !== 900"
          ref="stockStatusStep"
          :order-type="'stock'"
          :orderInfo="orderInfo"
        />
      </div>

      <!-- 主单信息 -->
      <div class="order-info-block">
        <div class="block-title">主单信息</div>
        <el-row :gutter="12">
          <el-form :model="orderInfo" label-width="120px">
            <el-col :span="12">
              <el-form-item label="出库单号">
                <span>{{ orderInfo.billNumber }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库名称">
                <span>{{ orderInfo.billName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库日期">
                <span v-if="orderInfo.stockOutTime">{{
                  orderInfo.stockOutTime | parseTime("{y}-{m}-{d}")
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库仓库">
                <span>{{ orderInfo.warehouseName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态">
                <span>{{ orderInfo.billStatusName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单备注">
                <span>{{ orderInfo.billRemark }}</span>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <!-- 订单明细 -->
      <div class="order-info-block">
        <div class="block-title">订单明细</div>
        <el-table :data="orderInfo.stockOrderDetailList" class="delivery-table">
          <el-table-column
            label="分类"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
          />
          <el-table-column
            label="商品"
            prop="itemName"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            label="出库数量"
            align="center"
            prop="itemQty"
            show-overflow-tooltip
          />
          <el-table-column
            label="区域编码"
            align="center"
            prop="orgCode"
            show-overflow-tooltip
          />
          <el-table-column
            label="品牌部门"
            align="center"
            prop="buTypeName"
            show-overflow-tooltip
          />
          <el-table-column
            label="收货人"
            align="center"
            prop="receivePerson"
            show-overflow-tooltip
          />
          <el-table-column
            label="收货地址"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.countyName }} {{ scope.row.detailAddress }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import stockStatusStep from './components/stock-status-step'
export default {
  name: 'stock-out-info',
  components: {
    ContentHeader,
    stockStatusStep
  },
  data () {
    return {
      loading: false,
      orderInfo: {},
      billId: ''
    }
  },
  computed: {
    navPathInfo () {
      let pathInfo = [
        { path: '/stock/stock', name: '库存' },
        { path: '/stock/stock-out', name: '出库订单列表' }
      ]
      return pathInfo
    }
  },
  created () {
    this.billId = this.$route.query.billId
    this.init()
  },
  methods: {
    init () {
      this.getInfo()
    },
    getInfo () {
      this.loading = true
      this.$store
        .dispatch('queryStockOrderInfo', this.billId)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.orderInfo = res.data.resultData.stockOrder
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取间隔时间
    getInterval (time) {
      let date = new Date().getTime()
      let intervalDate = date - time
      return Math.floor(intervalDate / 86400000) + 1
    }
  }
}
</script>

<style lang="scss" scoped>
.order-info-block {
  border-radius: 10px;
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;

  .block-title {
    line-height: 32px;
  }
}
.el-form-item {
  margin-bottom: 0;
}
.order-header {
  .order-number {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
  }
  .order-date {
    font-size: 16px;
    line-height: 30px;
  }
  .ongoing {
    margin-left: 15px;
  }
  .order-status {
    color: $base-red;
    padding: 16px 0;
  }
}
.order-detail {
  width: 100%;
  .item-image {
    width: 65px;
    height: 65px;
    margin: 0 auto;
    border: 1px solid $base-grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 90%;
      max-height: 90%;
    }
  }

  .item-name {
    text-align: left;
    font-weight: 700;
  }

  .item-sum {
    font-weight: 700;
  }
}

.order-amount {
  border: 2px dashed #db3e3e;
  margin: 10px 0 0 0;
  padding: 0 20px;
  color: #db3e3e;
  font-size: 16px;
  line-height: 32px;
}

.dotted-block {
  border: 2px dashed $base-grey3;
  vertical-align: middle;
  height: 80px;
}

.budget-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 30px;
  }
}
.entity-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 15px;
    & + p {
      margin-top: -5px;
    }
  }
}

.delivery-table {
  ::v-deep th {
    background-color: $base-grey3;
  }

  .receipt-image {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.order-remark {
  line-height: 32px;
}

.order-info-box {
  .order-info-card {
    width: 400px;
    height: 190px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 40px;
    div {
      margin-top: 9px;
    }
    &.card-red {
      border-color: $base-red;
      color: $base-orange;
      padding: 40px 0 0 130px;
      div {
        margin-top: 15px;
      }
    }
    .amount-msg {
      color: #333;
      font-size: 12px;
      margin-top: 5px !important;
    }
  }
}
.list-text {
  padding-bottom: 5px;
  display: inline-block;
}
.order-input {
  display: flex;
  margin: 10px 0;
  .el-input {
    width: 200px;
  }
}
.prints-img {
  display: flex;
  align-items: center;
  .print-img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}
.prints-ai {
  margin: 10px 0;
}
.prints-info {
  & > div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.sap-btn {
  text-align: right;
  margin-bottom: 15px;
}
.price-msg {
  margin-top: -5px;
}
.price-info {
  font-size: 12px;
  color: #999;
}
</style>
